/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-submission-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('dvsn-form-builder-submission-list', {
    template,

    inject: [
        'repositoryFactory'
    ],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing')
    ],

    data() {
        return {
            submissions: null,
            isLoading: true,
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        columns() {
            return this.getColumns();
        },

        repository() {
            return this.getRepository();
        },

        dateFilter() {
            return Shopware.Filter.getByName('date');
        },
    },

    methods: {
        getColumns() {
            return [{
                property: 'formId',
                dataIndex: 'formId',
                label: this.$t('dvsn-form-builder-submission.list.column-form'),
                allowResize: true
            }, {
                property: 'customerId',
                dataIndex: 'customerId',
                label: this.$t('dvsn-form-builder-submission.list.column-customer'),
                allowResize: true
            }, {
                property: 'salesChannelId',
                dataIndex: 'salesChannelId',
                label: this.$t('dvsn-form-builder-submission.list.column-sales-channel'),
                allowResize: true
            }, {
                property: 'createdAt',
                dataIndex: 'createdAt',
                label: this.$t('dvsn-form-builder-submission.list.column-created-at'),
                allowResize: true
            }];
        },

        getRepository() {
            return this.repositoryFactory.create('dvsn_form_builder_submission');
        },

        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria
                .addAssociation('form')
                .addAssociation('customer')
                .addAssociation('salesChannel')
                .addSorting(Criteria.sort('createdAt', 'DESC'));
            criteria.setTerm(this.term);

            this.repository
                .search(criteria, Shopware.Context.api)
                .then((result) => {

                    console.log(result);

                    this.submissions = result;
                    this.isLoading = false;
                });
        },
    },

    created() {
    }
});
